import React, { useState } from "react";
import { Form, Button, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import TextInput from "../ReusableInputs/TextInput";
import userServiceInstance from "../../APIs/users";
import { useNotification } from "../Toast/Notification";

const { Title, Text } = Typography;

// Loading component
const Loader = () => (
  <div className="flex items-center justify-center">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#75A7AD]"></div>
  </div>
);

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const location = useLocation();
  const [password, setPassword] = useState<string>("");
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const navigate = useNavigate();
  const { notify } = useNotification();

  const onFinish = async () => {
    setLoading(true);
    try {
      const response = await userServiceInstance.resetPassword(token, password);

      if (response.data) {
        notify("Password has been successfully reset", "success");
        navigate("/signin");
      } else {
        notify("Error resetting password. Please try again.", "error");
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      notify("An unexpected error occurred. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const validatePassword = (_: any, value: string) => {
    if (!value) {
      return Promise.reject(new Error("Please input your password"));
    }
    if (value.length < 8) {
      return Promise.reject(
        new Error("Password must be at least 8 characters long")
      );
    }
    if (!/[A-Z]/.test(value)) {
      return Promise.reject(
        new Error("Password must contain at least one uppercase letter")
      );
    }
    if (!/[\W_]/.test(value)) {
      return Promise.reject(
        new Error("Password must contain at least one special character")
      );
    }
    if (value.includes(" ")) {
      return Promise.reject(new Error("Password cannot contain spaces"));
    }
    return Promise.resolve();
  };

  return (
    <>
      <Header
        desktopHeight="auto"
        title="RESET PASSWORD"
        textBackground="RESET PASSWORD"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1729584914/sodastream/1729584914532.png"
        subTitle=""
      />

      <div className="relative w-full mt-[-35%] mb-[0px] lg:mb-[10px] p-4  opacity-80">
      <div className="flex items-center justify-center w-full">
          <div className="bg-white rounded-xl shadow-lg border border-[#75A7AD]/20 w-full max-w-[55%] p-8">
            <div className="text-center mb-6">
              <Title level={2} className="text-[#005D6E] m-0">Reset Your Password</Title>
              <Text className="text-gray-500">Create a new secure password for your account</Text>
            </div>

            <Form form={form} onFinish={onFinish} layout="vertical">
              <TextInput
                type="password"
                title="New Password"
                placeholder="Enter your new password"
                inputValue={password}
                setInputValue={setPassword}
                name="password"
                required={true}
                prefix={<LockOutlined className="text-[#75A7AD] mr-2" />}
                tooltipText="Must include uppercase, special character, and be at least 8 characters"
                rules={[{ validator: validatePassword }]}
              />

              <div className="mt-8">
                <Button
                  htmlType="submit"
                  className="w-full h-12 text-white font-medium rounded-full bg-gradient-to-r from-[#75A7AD] to-[#005D6E] hover:opacity-90 transition-all duration-300 flex items-center justify-center"
                  disabled={loading}
                >
                  {loading ? <Loader /> : "Reset Password"}
                </Button>
              </div>
            </Form>
          </div>
        </div>

      </div>

      
      <Footer />
    </>
  );
};

export default ResetPassword;